module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "Predefined"
    }
  }, [_c('el-select', {
    attrs: {
      "value": ""
    },
    on: {
      "input": _vm.updateCannedMsg
    }
  }, _vm._l((_vm.cannedMessages), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option.name,
        "value": option.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Recipient"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.message.email),
      callback: function($$v) {
        _vm.$set(_vm.message, "email", $$v)
      },
      expression: "message.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Subject"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.message.subject),
      callback: function($$v) {
        _vm.$set(_vm.message, "subject", $$v)
      },
      expression: "message.subject"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Message"
    }
  }, [_c('wysiwyg', {
    model: {
      value: (_vm.message.content),
      callback: function($$v) {
        _vm.$set(_vm.message, "content", $$v)
      },
      expression: "message.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59be357f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Messages.vue
// module id = 539
// module chunks = 1